<template>
    <div class="form-group"  v-bind:class="{ 'has-error' : controller.hasError,'has-warning' : controller.hasWarning ,'has-success' : controller.hasSuccess}">
        <label class="col-md-3 control-label">{{controller.name}}</label>
        <select class="form-control" id="select" v-model="controller.value" @blur="controller.value = controller.value">
                <option v-for="option in options">{{option}}</option>
            </select>
            <span class="help-block" v-if="controller.hasWarning || controller.hasError">
                <i class="fa" v-bind:class="{ 'fa-exclamation-circle' : controller.hasError,'fa-exclamation-triangle' : controller.hasWarning }"></i>
                <small>{{controller.message}}</small>
            </span>
        
    </div>
</template>
<script>

    export default {
        props: ['controller', 'options'],
        data: function () {
            return {

            }
        }
    }
</script>


// WEBPACK FOOTER //
// formselect.scp.html?3a386c43